// extracted by mini-css-extract-plugin
export default {"App":"App_App__LJNWd","App-logo":"App_App-logo__C5a91","App-logo-spin":"App_App-logo-spin__uDkCJ","App-header":"App_App-header__Zp30N","App-link":"App_App-link__t8xAU"};